document.addEventListener("DOMContentLoaded", () => {

    const inlineMenu = document.querySelector(".header__inline-menu");
    if (inlineMenu) {
        const dropdownItems = inlineMenu.querySelectorAll(".dropdown-item");
        dropdownItems.forEach((item) => {
          const submenu = item.querySelector("ul");
          if (submenu) {
            item.addEventListener("mouseenter", () => {
              item.classList.add("open");
              submenu.classList.add("open");
            });
            item.addEventListener("mouseleave", () => {
              item.classList.remove("open");
              submenu.classList.remove("open");
            });
          }
        });
        const megaMenus = inlineMenu.querySelectorAll(".mega-menu");
        megaMenus.forEach((menu) => {
            menu.addEventListener("mouseenter", () => {
            menu.setAttribute("open", "true");
            });
            menu.addEventListener("mouseleave", () => {
            menu.removeAttribute("open");
            });
        });
      }
    document.addEventListener("click", function (event) {

        if (event.target.closest(".second_dra_item")) {
          const drawerItem = event.target.closest('.second_drawer_menu');
          const innerSubmenu = drawerItem?.querySelector('.menu-drawer__inner-submenu');
          if (drawerItem && innerSubmenu) {
            document.querySelectorAll('.second_drawer_menu.drawOpen')
              .forEach(item => {
                if (item !== drawerItem) item.classList.remove('drawOpen');
              });
            drawerItem.classList.toggle('drawOpen');
          }
        }
        
        if (event.target.closest(".footer-block__heading, .summary__title")) {
          const footerItem = event.target.closest('.footer-block--menu, .product__accordion');
          const footerSubmenu = footerItem?.querySelector('.footer-block__details-content, .pv2-accordion__content');
          if (footerItem && footerSubmenu) {
            document.querySelectorAll('.footer-block--menu.drawOpen, .product__accordion.drawOpen')
              .forEach(item => {
                if (item !== footerItem) item.classList.remove('drawOpen');
              });
            footerItem.classList.toggle('drawOpen');
          }
        }
        
        if (event.target.closest(".menu-drawer__close-button")) {
          const lastItem = event.target.closest('.third_menu_drawer');
          const lastSubmenu = lastItem?.querySelector('.last_drawer');
          if (lastItem && lastSubmenu) {
            document.querySelectorAll('.third_menu_drawer.openSubmenu').forEach(item => {
              if (item !== lastItem) item.classList.remove('openSubmenu');
            });
            lastItem.classList.toggle('openSubmenu');
          }
        }
      
      const menuBtn = event.target.closest(".header__icon--menu");
      if (menuBtn) {
        const wrapper = menuBtn.closest(".menu_drawer_container_wrapper");
        if (wrapper) {
          wrapper.classList.toggle("open");
          document.body.classList.add("overflow-hidden");
        }
      }
      const overlay = event.target.closest(".drawer_overlay");
      if (overlay) {
        const wrapper = overlay.closest(".menu_drawer_container_wrapper");
        if (wrapper) {
          wrapper.classList.remove("open");
          document.body.classList.remove("overflow-hidden");
        }
      }
      const closeBtn = event.target.closest(".header__icon--button");
      if (closeBtn) {
        const wrapper = closeBtn.closest(".menu_drawer_container_wrapper");
        if (wrapper) {
          wrapper.classList.remove("open");
          document.body.classList.remove("overflow-hidden");
        }
      }

      if (
          event.target.matches(".card_atc") ||
          event.target.closest(".card_atc")
        ) {
          event.preventDefault();
          event.stopPropagation();
          
          const target = event.target.matches(".card_atc")
            ? event.target
            : event.target.closest(".card_atc");
          if (target.classList.contains("loading")) {
            return;
          }
          
          const id = parseInt(target.getAttribute("data-variant"));
          
          if (!id || isNaN(id)) {
            console.log("Invalid variant ID");
            return;
          }
          
          target.classList.add("loading");
          window.updateCartDrawer(id, target);
          setTimeout(() => {
              document.querySelector("#cart-icon-bubble")?.click();
            }, 30);
        }
    });
});
if (/iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
  document.body.classList.add("is-iphone");
}
window.updateCartDrawer = function (id, target) {
  const sectionsToRender = [
    {
      id: "CartDrawer",
      section: "cart-drawer",
      selector: ".drawer__inner",
    },
    {
      id: "cartIconBubble",
      section: "cart-icon-bubble",
      selector: ".cart-count-section",
    },
  ];

  let formData = new FormData();
  formData.append("id", id);
  formData.append("quantity", 1);
  formData.append(
    "sections",
    sectionsToRender.map((section) => section.section).join(",")
  );
  formData.append("sections_url", window.location.pathname);

  fetch(`/cart/add.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: new URLSearchParams(formData).toString(),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then((data) => {
      target?.classList.remove("loading");
      if (data.status === 422 || data.description) {
        console.error("Error:", data.message || data.description);
        alert(data.message || data.description || "Failed to add to cart");
        return;
      }

      console.log("Product added successfully:", data);
      document.querySelector("cart-drawer")?.classList.remove("is-empty");
      if (data.sections) {
        sectionsToRender.forEach((section) => {
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);

          if (sectionElement && data.sections[section.section]) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(
              data.sections[section.section],
              "text/html"
            );
            const newContent = doc.querySelector(section.selector);
            
            if (newContent) {
              sectionElement.innerHTML = newContent.innerHTML;
            }
          }
        });
      }
      
    })
    .catch((error) => {
      target?.classList.remove("loading");
      console.error("Fetch error:", error);
      alert("Failed to add product to cart. Please try again.");
    });
};